@if ({
  invoiceOverview: invoiceOverview$ | async,
  errorOverview: errorOverview$ | async
  }; as type) {
  @if (balance) {
    <!--Balance-->
    <div class="balanceData tableContainer">
      <div class="row">
        <div class="col-md-2 balanceTitle">
          <p>{{ 'customUserPayments.balanceWarehouse' | cxTranslate }}</p>
        </div>
        <div class="col-md-2 text-right">
          <p>&euro; {{ balance.balanceWarehouse }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 balanceTitle">
          <p>{{ 'customUserPayments.balanceThirdParty' | cxTranslate }}</p>
        </div>
        <div class="col-md-2 text-right" >
          <p>&euro; {{ balance.balanceThirdParty }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2 balanceTitle">
          <p>{{ 'customUserPayments.balance' | cxTranslate }}</p>
        </div>
        <div class="col-md-2 text-right">
          <p>&euro; {{ balance.balanceValue }}</p>
        </div>
      </div>
      <hr>
      </div>
    }
    <!-- Filter and search -->
    <div class="user-payments-filter">
      <form (ngSubmit)="onSubmit()" #searchForm="ngForm" autocomplete="off">
        <div class="form-group row">
          <label for="invoiceDateFrom" class="col-xl-2 col-form-label">{{
            'customUserPayments.search.invoiceDateFrom' | cxTranslate
          }}</label>
          <div class="col-xl-2">
            <input
              type="date"
              id="invoiceDateFrom"
              class="form-control"
              name="invoiceDateFrom"
              [(ngModel)]= "invoiceDateFrom"
              [(value)]="invoiceDateFrom"
              min="{{ invoiceDateFromMin }}"
              max="{{ invoiceDateFromMax | date: 'yyyy-MM-dd' }}"
              (change)="changeInvoiceDateFrom($event)"
              />
            </div>
            <label for="invoiceDateTo" class="col-xl-2 col-form-label">{{
              'customUserPayments.search.invoiceDateTo' | cxTranslate
            }}</label>
            <div class="col-xl-2">
              <input
                type="date"
                id="invoiceDateTo"
                class="form-control"
                [(ngModel)]= "invoiceDateTo"
                name="invoiceDateTo"
                [(value)]="invoiceDateTo"
                min="{{ invoiceDateToMin }}"
                max="{{ invoiceDateToMax | date: 'yyyy-MM-dd' }}"
                (change)="changeInvoiceDateTo($event)"
                />
              </div>
            </div>
            <div class="form-group row">
              <label for="amountFrom" class="col-xl-2 col-form-label">{{
                'customUserPayments.search.amountFrom' | cxTranslate
              }}</label>
              <div class="col-xl-2">
                <input
                  type="text"
                  id="amountFrom"
                  class="form-control"
                  [(ngModel)]="amountFrom"
                  name="amountFrom"
                  [value]="amountFrom"
                  />
                </div>
                <label for="amountTo" class="col-xl-2 col-form-label">{{
                  'customUserPayments.search.amountTo' | cxTranslate
                }}</label>
                <div class="col-xl-2">
                  <input
                    type="text"
                    id="amountTo"
                    class="form-control"
                    [(ngModel)]="amountTo"
                    name="amountTo"
                    [value]="amountTo"
                    />
                  </div>
                  <label for="invoiceNumber" class="col-xl-2 col-form-label">{{
                    'customUserPayments.search.invoiceNumber' | cxTranslate
                  }}</label>
                  <div class="col-xl-2">
                    <input
                      type="text"
                      id="invoiceNumber"
                      class="form-control"
                      [(ngModel)]="invoiceNumber"
                      name="invoiceNumber"
                      [value]="invoiceNumber"
                      />
                    </div>
                  </div>
                  <div class="form-group row">
                    <label for="referenceNumber" class="col-xl-2 col-form-label">{{
                      'customUserPayments.search.referenceNumber' | cxTranslate
                    }}</label>
                    <div class="col-xl-2">
                      <input
                        type="text"
                        id="referenceNumber"
                        class="form-control"
                        [(ngModel)]="referenceNumber"
                        name="referenceNumber"
                        [value]="referenceNumber"
                        />
                      </div>
                      <label for="articleNumber" class="col-xl-2 col-form-label">{{
                        'customUserPayments.search.articleNumber' | cxTranslate
                      }}</label>
                      <div class="col-xl-2">
                        <input
                          type="text"
                          id="articleNumber"
                          class="form-control"
                          [(ngModel)]="articleNumber"
                          name="articleNumber"
                          [value]="articleNumber"
                          />
                        </div>
                        <label for="notificationNumber" class="col-xl-2 col-form-label">{{
                          'customUserPayments.search.notificationNumber' | cxTranslate
                        }}</label>
                        <div class="col-xl-2">
                          <input
                            type="text"
                            id="notificationNumber"
                            class="form-control"
                            [(ngModel)]="notificationNumber"
                            name="notificationNumber"
                            [value]="notificationNumber"
                            />
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="orderType" class="col-xl-2 col-form-label">{{
                            'customUserPayments.search.orderType' | cxTranslate
                          }}</label>
                          <ng-select
                            id="orderType"
                            name="orderType"
                            class="col-xl-2"
                            [searchable]="false"
                            [clearable]="false"
                            [(ngModel)]="orderType"
                            >
                            @for (orderType of orderTypes; track orderType) {
                              <ng-option [value]="orderType">{{
                                'customUserPayments.orderType.' + orderType | cxTranslate
                              }}</ng-option>
                            }
                          </ng-select>
                          <label for="bookingType" class="col-xl-2 col-form-label">{{
                            'customUserPayments.search.bookingType' | cxTranslate
                          }}</label>
                          <ng-select
                            id="bookingType"
                            name="bookingType"
                            class="col-xl-2"
                            [searchable]="false"
                            [clearable]="false"
                            [(ngModel)]="bookingType"
                            >
                            @for (bookingType of bookingTypes; track bookingType) {
                              <ng-option [value]="bookingType">{{
                                'customUserPayments.bookingType.' + bookingType | cxTranslate
                              }}</ng-option>
                            }
                          </ng-select>
                          <label for="openPositions" class="col-xl-2 col-form-label">{{
                            'customUserPayments.search.openPositions' | cxTranslate
                          }}</label>
                          <div class="col-xl-2 only-open-checkbox form-check">
                            <input
                              type="checkbox"
                              id="openPositions"
                              class="form-control col-xl-2"
                              [(ngModel)]="openPositions"
                              name="openPositions"
                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-sm-4">
                              <button class="btn btn-secondary btn-block mb-3" type="submit">
                                {{ 'customUserPayments.buttons.search' | cxTranslate }}
                              </button>
                            </div>
                            <div class="col-sm-4">
                              <button class="btn btn-secondary btn-block mb-3" (click)="resetSearchForm()">
                                {{ 'customUserPayments.buttons.reset' | cxTranslate }}
                              </button>
                            </div>
                            <div class="col-sm-4">
                              @if (!errorOverview) {
                                <button
                                  class="btn btn-secondary btn-block mb-3"
                                  type="button"
                                  (click)="onExport()"
                                  >
                                  {{ 'customUserPayments.buttons.export' | cxTranslate }}
                                </button>
                              }
                            </div>
                          </div>
                        </form>
                      </div>
                      <!-- Sorting -->
                      <div class="user-payments-sort">
                        <div class="form-group row">
                          <label for="userPaymentsSorting" class="col-xl-2 col-form-label">{{
                            'customUserPayments.sortOptions.label' | cxTranslate
                          }}</label>
                          <ng-select
                            id="sortOptions"
                            class="col-xl-2"
                            [searchable]="false"
                            [clearable]="false"
                            (change)="onChangeSort()"
                            [(ngModel)]="selectedSortOption"
                            >
                            @for (sort of sortOptions; track sort) {
                              <ng-option [value]="sort">{{
                                'customUserPayments.sortOptions.' + sort | cxTranslate
                              }}</ng-option>
                            }
                          </ng-select>
                          <label for="sortDirections" class="col-xl-2 col-form-label">{{
                            'customUserPayments.sortDirections' | cxTranslate
                          }}</label>
                          <div class="col-xl-2 col-form-label">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="sortDirection"
                                id="sortDirectionDesc"
                                value="desc"
                                ng-control="sortDirection"
                                [(ngModel)]="sortDirection"
                                (change)="onChangeSort()"
                                />
                                <label class="form-check-label" for="sortDirectionDesc">
                                  {{ 'customUserPayments.sortDirection.desc' | cxTranslate }}
                                </label>
                              </div>
                            </div>
                            <div class="col-xl-2 col-form-label">
                              <div class="form-check">
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="sortDirection"
                                  id="sortDirectionAsc"
                                  value="asc"
                                  ng-control="sortDirection"
                                  [(ngModel)]="sortDirection"
                                  (change)="onChangeSort()"
                                  />
                                  <label class="form-check-label" for="sortDirectionAsc">
                                    {{ 'customUserPayments.sortDirection.asc' | cxTranslate }}
                                  </label>
                                </div>
                              </div>
                              <div class="col-xl-2 col-form-label">
                                <div>
                                  <div class="openIndicator">
                                    <p class="openPaymentIndicator"> </p>
                                  </div>
                                  <div class="openIndicator">
                                    <p class="indicatorsLabel"> {{ 'customUserPayments.open' | cxTranslate }} </p>
                                  </div>
                                </div>
                                <div>
                                  <div class="closedIndicator">
                                    <p class="closedPaymentIndicator"> </p>
                                  </div>
                                  <div class="closedIndicator">
                                    <p class="indicatorsLabel"> {{ 'customUserPayments.closed' | cxTranslate }} </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          @if (invoiceOverview || errorOverview) {
                            <div class="tableContainer">
                              <!-- TABLE -->
                              <table class="table user-payments-table">
                                <thead class="user-payments-thead-mobile">
                                  <th scope="col" class="invoice">
                                    {{ 'customUserPayments.invoice' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="reference">
                                    {{ 'customUserPayments.reference' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="invoiceDate">
                                    {{ 'customUserPayments.invoiceDate' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="dueDate">
                                    {{ 'customUserPayments.dueDate' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="amount">
                                    {{ 'customUserPayments.amount' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="debitOrCredit">
                                    {{ 'customUserPayments.debitOrCredit' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="warehouseOrThirdparty">
                                    {{ 'customUserPayments.warehouseOrThirdparty' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="notificationNo">
                                    {{ 'customUserPayments.notificationNo' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="notificationDate">
                                    {{ 'customUserPayments.notificationDate' | cxTranslate }}
                                  </th>
                                  <th scope="col">
                                    &nbsp;
                                  </th>
                                  <th scope="col" class="discountValue">
                                    {{ 'customUserPayments.discountValue' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="collectionAmount">
                                    {{ 'customUserPayments.collectionAmount' | cxTranslate }}
                                  </th>
                                  <th scope="col" class="accumulatedValue">
                                    {{ 'customUserPayments.accumulatedValue' | cxTranslate }}
                                  </th>
                                </thead>
                                <tbody>
                                  @if (invoices.length === 0) {
                                    <tr>
                                      <td class="emptyTable" colspan="13">
                                        {{  'customUserPayments.emptyTable' | cxTranslate }}
                                      </td>
                                    </tr>
                                  }
                                  @for (invoice of invoices; track invoice) {
                                    <tr>
                                      <!--Invoice Number-->
                                      <td class="invoiceNumber">
                                        <div class="d-md-none user-payments-label">
                                          {{ 'customUserPayments.invoice' | cxTranslate }}
                                        </div>
                                        <div class="user-payments-value">
                                          <a
                    [routerLink]="
                    {
                      cxRoute: 'userPaymentsDetails',
                      params: {
                         invoiceNumber: invoice?.invoiceNumber,
                         companyCode: invoice?.companyCode,
                         bookingYear: invoice?.bookingYear,
                         bookingTime: invoice?.bookingTime
                       }
                    } | cxUrl
                    "
                                          class="user-payments-value">
                                          {{ invoice?.invoiceNumber }}
                                        </a>
                                        @switch (invoice.invoiceStatus) {
                                          @case ('X') {
                                            <div class="openPaymentIndicator"></div>
                                          }
                                          @default {
                                            <div class="closedPaymentIndicator"></div>
                                          }
                                        }
                                        @if (invoice.pdfUrl) {
                                          <div class="custom-user-payments__invoice-pdf invoicePdf">
                                            <a class="user-payments-value" (click)="getPdf(invoice.pdfUrl)">
                                              {{ 'customUserPayments.pdf' | cxTranslate }}
                                            </a>
                                          </div>
                                        }
                                      </div>
                                    </td>
                                    <!--Reference Number-->
                                    <td class="referenceNumber">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.reference' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        {{ invoice?.referenceNumber }}
                                      </div>
                                    </td>
                                    <!--Invoice Date-->
                                    <td class="invoiceDate">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.invoiceDate' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        {{ invoice?.formattedInvoiceDate }}
                                      </div>
                                    </td>
                                    <!--Due Date-->
                                    <td class="dueDate">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.dueDate' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        {{ invoice?.formattedDueDate }}
                                      </div>
                                    </td>
                                    <!--Amount-->
                                    <td class="amount">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.amount' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        {{ invoice?.amountFormattedValue }}
                                      </div>
                                    </td>
                                    <!--Debit or Credit-->
                                    <td class="debitOrCredit">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.debitOrCredit' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        {{ invoice?.debitOrCredit }}
                                      </div>
                                    </td>
                                    <!--Warehouse or Thirdparty-->
                                    <td class="warehouseOrThirdparty">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.warehouseOrThirdparty' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        {{ invoice?.deliveryStatus }}
                                      </div>
                                    </td>
                                    <!--Notification Number-->
                                    <td class="notificationNo">
                                      <div class="d-md-none user-payments-label">
                                        {{ 'customUserPayments.notificationNo' | cxTranslate }}
                                      </div>
                                      <div class="user-payments-value">
                                        <a
                    [routerLink]="
                    {
                      cxRoute: 'userPaymentsAvis',
                      params: {
                         avisNumber: invoice?.notificationNumber,
                         avisDate: invoice?.notificationDate | cxDate: 'yyyy-MM-dd'
                       }
                    } | cxUrl
                    "
                                        class="user-payments-value">
                                        {{ invoice?.notificationNumber }}
                                      </a>
                                    </div>
                                  </td>
                                  <!--Notification Date-->
                                  <td class="notificationDate">
                                    <div class="d-md-none user-payments-label">
                                      {{ 'customUserPayments.notificationDate' | cxTranslate }}
                                    </div>
                                    <div class="user-payments-value">
                                      {{ invoice?.notificationDate | cxDate: 'mediumDate' }}
                                    </div>
                                  </td>
                                  <!--Delivery PDF-->
                                  <td class="custom-user-payments__delivery-pdf deliveryPdf">
                                    <div class="d-md-none user-payments-label">
                                      &nbsp;
                                    </div>
                                    @if (invoice.deliveryPdfUrl) {
                                      <div>
                                        <a class="user-payments-value" (click)="getPdf(invoice.deliveryPdfUrl)">
                                          {{ 'customUserPayments.pdf' | cxTranslate }}
                                        </a>
                                      </div>
                                    }
                                  </td>
                                  <!--Discount Value-->
                                  <td class="discountValue">
                                    <div class="d-md-none user-payments-label">
                                      {{ 'customUserPayments.discountValue' | cxTranslate }}
                                    </div>
                                    <div class="user-payments-value">
                                      {{ invoice?.discountFormattedValue }}
                                    </div>
                                  </td>
                                  <!--Collection Amount-->
                                  <td class="collectionAmount">
                                    <div class="d-md-none user-payments-label">
                                      {{ 'customUserPayments.collectionAmount' | cxTranslate  }}
                                    </div>
                                    <div class="user-payments-value">
                                      {{ invoice?.collectedAmountFormattedValue }}
                                    </div>
                                  </td>
                                  <!--Accumulated Value-->
                                  <td class="accumulatedValue">
                                    <div class="d-md-none user-payments-label">
                                      {{ 'customUserPayments.accumulatedValue' | cxTranslate }}
                                    </div>
                                    <div class="user-payments-value">
                                      {{ invoice?.accumulatedFormattedValue }}
                                    </div>
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      } @else {
                        <cx-spinner></cx-spinner>
                      }
                    }
